import React from 'react';
import clsx from 'clsx';
import { CollapsiblePanel } from '../CollapsiblePanel';
import { CollapsiblePanelWithActionsProps } from './types';
import { styles } from './styles';

export const CollapsiblePanelWithActions: React.FC<CollapsiblePanelWithActionsProps> = ({
  title,
  description,
  actions,
  children,
  defaultExpanded = false,
  descriptionClassName,
}) => {
  return (
    <CollapsiblePanel title={title} defaultExpanded={defaultExpanded}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={clsx(styles.description, descriptionClassName)}>{description}</span>
          {actions != null && <div className={styles.actionsRow}>{actions}</div>}
        </div>
        {children}
      </div>
    </CollapsiblePanel>
  );
};

export type { CollapsiblePanelWithActionsProps } from './types';
export default CollapsiblePanelWithActions;
